import React, { useContext, useEffect, useRef, useState } from 'react';
import { accesscontrols, getSearchResultIdsAll, performSearch, TsSearchSchemaBase } from '../Components/useGlobalSearch';
import { useLocation, useNavigate, useParams } from 'react-router';
import { SearchResult } from '../Components//SearchPopup/NewSearchColumn';
import { SearchMenuContext } from '../Contexts/SearchMenuContext';
import { TableDataContext } from '../Contexts/TableDataContext';
import routePathSegments, { routeNames } from '../routeSegments';
import useModule from '../hooks/useModule';
import { HeaderMenuContext } from '../Contexts/HeaderMenuContext';
import { PeFilterContext } from '../Contexts/PeFilterContext';
import moment from "moment";
import SliderLabels from './SliderLabels';
import axios from 'axios';
import { setGSSearchLog } from '../Config/config';
import TopResultColumn from '../Components/SearchPopup/TopResultColumn';
import { UserContext } from '../Contexts/UserContext';

// Loading spinner component for buttons
const LoadingSpinner = () => (
  <svg 
    className="animate-spin h-4 w-4 text-white" 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24"
  >
    <circle 
      className="opacity-25" 
      cx="12" 
      cy="12" 
      r="10" 
      stroke="currentColor" 
      strokeWidth="4"
    ></circle>
    <path 
      className="opacity-75" 
      fill="currentColor" 
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);


const NewSearchResult = ({menu}) => {
    const { setGlobalSearchResult, gsResultFound, setGSResultFound } = useContext(TableDataContext);
    const [searchResult, setSearchResult] = useState([]);
    const [selectedResult, setSelectedResult] = useState();
    const [selectedStaticHeaders, setSelectedStaticHeaders] = useState("Top Results");
    const [selected, setSelected] = useState("pe_investment");
    const [check,setCheck] = useState(true)
    const location = useLocation();
    const [isloading, setIsLoading] = useState(true);
    const { getToken, logout } = useContext(UserContext);
    const initialPageState = {
        "top_results": 1,
        "pe_investment": 1,
        "pe_exit": 1,
        "pe_ipo": 1,
        "angel": 1,
        "incubation": 1,
        "pe_investor": 1,
        "angel_investor": 1,
        "incubator": 1,
        "pe_fund": 1,
        "limited_partner": 1,
        "pe_advisor": 1,
        "merger_acquisition": 1,
        "pe_acquirer": 1,
        "re_investment": 1,
        "re_exit": 1,
        "re_ipo": 1,
        "re_investor": 1,
        "re_advisor": 1,
        "re_fund": 1,
        "re_merger_acquisition": 1,
        "cfs_company": 1
    }
    const [page, setPage] = useState(initialPageState);
    const { staticHeaders, peStaticHeaders, vcStaticHeaders, reStaticHeaders, maStaticHeaders, cfsStaticHeaders } = useContext(SearchMenuContext);
    const navigate = useNavigate();
    const { isVC, isMA, isPE, isDadhboard, isRE } = useModule();
    const { type, input } = useParams();
    const searchType = parseInt(type);
    const [searchInput, setSearchInput] = useState(input)
    const { setSearchText } = useContext(HeaderMenuContext);
    const { setMonthPickerValue, setDealsView, setShowChartPopup } = useContext(PeFilterContext);
    const [gsExpand , setgsExpand] = useState(false)
    const [isViewMore, setIsViewMore] = useState(false);   
    const [loadingCollections, setLoadingCollections] = useState({}); // Track loading state for each collection
    const [loadingViewMore, setLoadingViewMore] = useState({}); // Track loading state for view more buttons   

    const collectionNameMapHuman = {
      pe_company: 'Transacted Company',
      re_company: 'PE-RE Backed Company',
      cfs_company: 'Private Company Financials (CFS)',
      pe_investor: 'PE-VC Investors',
      angel_investor: 'Angel Investor',
      incubator: 'Incubator',
      limited_partner: 'Limited Partner',
      pe_fund: 'PE-VC Fund Raising',
      re_investor: 'PE-RE Investors',
      pe_acquirer: 'Acquirer (M&A)',
      pe_advisor: () => {
        // const hits = collection.hits || collection.grouped_hits || [];
        const prefix = isDadhboard ? 'PE-VC / M&A' : (isMA ? 'M&A' : (isVC || isPE ? 'PE-VC' : 'PE'));
        return `${prefix} Advisors`;
      },
      re_advisor: 'RE Advisors',      
      pe_investment: 'PE-VC Investments',
      re_investment: 'PE-RE Investments',
      angel: 'Angel Investments',
      incubation: 'Incubation',
      merger_acquisition: 'M&A Deals',
      pe_exit: 'PE-VC Exits',
      re_exit: 'PE-RE Exits',
      re_merger_acquisition: 'RE-Other M&A',
      pe_ipo: 'PE-VC Backed IPOs',
      re_ipo: 'PE-RE Backed IPOs',
      re_fund: 'PE-RE Fund Raising'
    }
    
    const areAllAccessControlsEmpty = () => {
      const arrs = accesscontrols ? [
        accesscontrols?.peindustries?.id,
        accesscontrols?.pe_tags?.id,
        accesscontrols?.pe_stage?.id,
        accesscontrols?.pe_countries?.id,
        accesscontrols?.pe_regions?.id,
        accesscontrols?.pe_states?.id,
        accesscontrols?.pe_cities?.id,
        accesscontrols?.maindustries?.id,
        accesscontrols?.ma_countries?.id,
        accesscontrols?.ma_regions?.id,
        accesscontrols?.ma_states?.id,
        accesscontrols?.ma_cities?.id,
        accesscontrols?.cfsindustries?.id
      ] : [];
      return arrs?.every(arr => Array.isArray(arr) && arr.length === 0);
    };
    
    const baseQuery = {
      q: searchType === 1 ? `"${searchInput}"` : searchInput,
      page: 1,
      per_page: 5,
      snippet_threshold: 20,
      num_typos: searchType === 0 ? 2 : 0,
      typo_tokens_threshold: searchType === 0 ? 10 : 0,
      split_join_tokens: searchType === 0 ? "fallback" : "off",
      drop_tokens_threshold: searchType === 0 ? 1 : 0
    };
    
    const showTopResults = areAllAccessControlsEmpty();

    const top_results = showTopResults
      ? (isDadhboard
          ? {
              ...baseQuery,
              collection: "top_results",
              query_by: "name, fund__name, full_name",
            }
          : isPE || isVC || isRE
          ? {
              ...baseQuery,
              collection: "top_results",
              query_by: "name, fund__name",
              filter_by:
                isPE || isVC
                  ? "collection_name: [pe_company, pe_investor, angel_investor, incubator, pe_fund, limited_partner, pe_advisor]"
                  : "collection_name: [re_company, re_investor, re_advisor, re_fund]",
            }
          : null)
      : null;


  const fundsParams = isPE || isVC ? TsSearchSchemaBase.filter((queryConf) => queryConf.collection === "pe_fund") : isRE ? TsSearchSchemaBase.filter((queryConf) => queryConf.collection === "re_fund") : null;
  
  const searchBasePath = location.pathname.split(`/${routePathSegments.globalSearch}/`)[0];
  const isPeFundsSearch = searchBasePath.endsWith("pe/funds");
  const isReFundsSearch = searchBasePath.endsWith("re/funds");
  const isVcFundsSearch = searchBasePath.endsWith("vc/funds");

  const searchParameters = isPeFundsSearch || isReFundsSearch || isVcFundsSearch ?
    fundsParams.map((queryConf) => ({
      ...queryConf,
    ...baseQuery,
    }))
   : [
    ...(top_results ? [top_results] : []),
    ...TsSearchSchemaBase.map((queryConf) => ({
      ...baseQuery,
      ...queryConf,
    })),
  ];

    const viewMoreHandler = async (collection_name) => {
      // Set loading state for this collection's view more
      setLoadingViewMore(prev => ({ ...prev, [collection_name]: true }));
      
      setIsViewMore(true);
      // console.log(page[collection_name], "from child")
      setPage((prev) => ({
        ...prev,
        [collection_name]: prev[collection_name] + 1
      }));

      try {
        const schema = searchParameters?.filter((schema) => schema.collection === collection_name)
          .map((queryConf) => ({
            ...queryConf,
            q: searchType === 1 ? `"${searchInput}"` : searchInput,
            page: page[collection_name] + 1
          }));

        const response = await performSearch(schema);
        
        const updatedResults = searchResult.reduce((acc, cur) => {
          if(cur.request_params.collection_name === response.results[0]?.request_params.collection_name){
            response.results[0].grouped_hits ? cur.grouped_hits.push(...response.results[0].grouped_hits) : cur.hits.push(...response.results[0].hits)
            cur.page = response.results[0].page;
            setCheck(!check)
          }
          acc.push(cur);
          return acc
        }, [])

        setSearchResult(updatedResults);
      } catch (error) {
        console.error('Error in viewMoreHandler:', error);
      } finally {
        // Clear loading state for this collection's view more
        setLoadingViewMore(prev => ({ ...prev, [collection_name]: false }));
      }
  };
  


  const fetchResults = async (searchInput, searchParameters) => {
    if (searchInput.length < 3) return null;

    try {
      // console.log(searchType, "type")
      const results = await performSearch(searchParameters);

      if (results.results.every((result) => result.found === 0)) {
        setSearchResult([]);
        console.log("No results found for the query.");
      } else {
        setSearchResult(results.results);

        axios.post(setGSSearchLog, {
          search_term: searchInput,
          type: ["pe", "vc"].includes(menu) ? "pe_primary" : menu || "dashboard",
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: getToken(),
          },
        });
      } 
    } catch (error) {
      console.error("An error occurred while fetching results:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    fetchResults(searchInput, searchParameters);
  }, [searchInput, searchType]);
  
  // Effect to check if 'top_results' exists and set static headers accordingly
  useEffect(() => {

    if (!searchResult.length || isViewMore) return;

    const staticHeadersMap = {
      dashboard: staticHeaders,
      pe: peStaticHeaders,
      vc: peStaticHeaders,
      re: reStaticHeaders,
      ma: maStaticHeaders,
      cfs: cfsStaticHeaders,
    };

    for (const [headerKey, headerGroups] of Object.entries(staticHeadersMap[menu])) {
      let staticHeader = "";
      for (const group of headerGroups) {
        if (searchResult.some((result) => result.request_params.collection_name === group.accessor && result.found > 0)) {
          staticHeader = headerKey
          setSelectedStaticHeaders(staticHeader);
          setSelected(group.accessor);
          break;
        }

      }
      if (staticHeader) break;
    }
  }, [searchResult, menu]);  
  

    const onOptionClick = () => {
      setSearchResult([]);
      setPage(initialPageState);
      setLoadingCollections({}); // Clear all loading states
      setLoadingViewMore({}); // Clear all view more loading states
    }

    useEffect(() => {
      onOptionClick();
    }, [location.pathname]);

    // Clear loading states when search input changes
    useEffect(() => {
      setLoadingCollections({});
      setLoadingViewMore({});
    }, [searchInput, searchType]);

    const columnsLinks = [
      // {accessor: "pe_company", link: (!isVC) ? routeNames.pe_companies_pe_vc_investments  : routeNames.vc_companies_vc_investments, dealsView: false},
      // {accessor:"re_company", link: routeNames.re_companies_re_investments},
      {accessor:"cfs_company", link: routeNames.cfs},

      {accessor: "pe_investor", link: (!isVC) ? routeNames.pe_investors_pe_vc_investments : routeNames.vc_investors_vc_investments},
      {accessor: "angel_investor", link: (!isVC) ? routeNames.pe_investors_angel_investments : routeNames.vc_investors_angel_investments},
      {accessor: "incubator", link: (!isVC) ? routeNames.pe_investors_incubation : routeNames.vc_investors_incubation},
      {accessor: "pe_fund", link: (!isVC) ? routeNames.pe_investors_pe_vc_funds : routeNames.vc_investors_vc_funds},
      {accessor:"re_investor", link: routeNames.re_investors_re_investments},
      {accessor:"pe_advisor", link: (isMA) ? routeNames.MA_advisors : routeNames.pe_advisors_pe_vc_advisors},
      {accessor:"re_advisor", link: routeNames.re_advisors_re_investments},

      {accessor:"pe_acquirer", link: routeNames.ma_acquires},
      {accessor: "pe_investment", link: (!isVC) ? routeNames.pe_companies_pe_vc_investments : routeNames.vc_companies_vc_investments, dealsView: true},
      {accessor: "pe_exit", link: (!isVC) ? routeNames.pe_companies_exists_pe_vc_investments : routeNames.vc_companies_exists_vc_investments, dealsView: true},
      {accessor: "pe_ipo", link: (!isVC) ? routeNames.pe_companies_backed_ipos_pe_vc_investments : routeNames.vc_companies_backed_ipos_vc_investments, dealsView: true},
      {accessor: "angel", link: (!isVC) ? routeNames.pe_companies_angel_investments : routeNames.vc_companies_angel_investments, dealsView: true},
      {accessor: "incubation", link: (!isVC) ? routeNames.pe_companies_incubation : routeNames.vc_companies_incubation, dealsView: true},
      {accessor:"merger_acquisition", link: routeNames.ma_companies},
      {accessor:"re_investment", link: routeNames.re_companies_re_investments},
      {accessor:"re_exit", link: routeNames.re_companies_re_exits},
      {accessor:"re_ipo", link: routeNames.re_companies_re_ipo},
      {accessor:"limited_partner", link: (isVC) ? routeNames.vc_investors_vc_limited_partners : routeNames.pe_investors_pe_vc_limited_partners},
      {accessor:"re_fund", link: routeNames.re_investors_funds},
      {accessor:"re_merger_acquisition", link: routeNames.re_companies_other_ma}
    ];
    
    const foundMap = searchResult.reduce((acc, result) => {
      if (result.request_params) {
        const accessor = result.request_params.collection_name;
        acc[accessor] = result.found_docs || result.found;
      }
      return acc;
    }, {});

    const resultsContainerRef = useRef(null);

    const scrollToTop = () => {
        if (resultsContainerRef.current) {
            resultsContainerRef.current.scrollTop = 0;
        }
    };

    const handleHeaderClick = (headerKey, accessor) => {
        setSelectedStaticHeaders(headerKey);
        setSelected(accessor);
        
        setTimeout(() => {
            if (headerKey === "More Results From Other Database") {
                scrollToTop();
            } else {
                const element = document.getElementById(accessor);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            }
        }, 100);
    };

    console.log(selected, selectedStaticHeaders, "selected sub header");

    const RenderHeaders = ({headers}) => {
        return (
            <div className='md:pb-2 sticky'>
                <div className='pl-4 mb-2 flex flex-row items-center gap-6 bg-white'>
                    {Object.keys(headers).map((headerKey, i) => {
                        const totalFound = headers[headerKey]?.reduce((sum, h) => sum + (foundMap[h.accessor] || 0), 0);
                        if (totalFound === 0) {
                            return null;
                        }
                        const subHeaderResultFound = headers[headerKey].findIndex(h => foundMap[h.accessor] > 0);
                        return (
                            <div 
                                key={i} 
                                className={`py-1 px-4 text-black text-[15px] ${
                                    headerKey === selectedStaticHeaders ? 
                                    "border-b-[3px] border-b-[#F1CA75] font-semibold" : 
                                    "cursor-pointer"
                                }`} 
                                onClick={() => handleHeaderClick(headerKey, headers[headerKey][subHeaderResultFound].accessor)}
                            >
                                {headerKey}
                                <span className="text-xs ml-1">({addCommasToNumber(totalFound)})</span>
                            </div>
                        );
                    })}
                </div>
                <div className={`flex flex-row-reverse items-start  border-b ${gsExpand ? 'px-2 ' : 'p-2'}`}>
                    <RenderLabels header={headers[selectedStaticHeaders]} />
                </div>
            </div>
        );
    };


    const RenderLabels = ({ header }) => {
      if(header?.filter(h => foundMap[h.accessor] > 0).length > 7){
        setgsExpand(true)
      }else{
          setgsExpand(false)
      }
      return (
        <div className={`w-full px-2 rounded ${gsExpand ? 'my-2' : ''}`}>
          <SliderLabels 
            header={header}
            selected={selected}
            setSelected={setSelected}
            foundMap={foundMap}
            addCommasToNumber={addCommasToNumber}
            gsExpand={gsExpand}
          />
        </div>
      );
    };

    const viewAllHandler = async (collection, labelState) => {
      setGSResultFound(foundMap);

      // Set loading state for this collection
      setLoadingCollections(prev => ({ ...prev, [collection]: true }));

      // Show loading state for large datasets
      const recordCount = foundMap[collection];
      const isLargeDataset = recordCount > 12500; // More than API single request limit
      
      if (isLargeDataset) {
        console.log(`Processing large dataset: ${recordCount} records. This may take a moment...`);
      }

      try {
        // Always fetch IDs for the specific collection only
        const searchResultsId = await getSearchResultIdsAll(
          searchInput,
          recordCount,
          searchType,
          [collection],  // Only fetch IDs for the specific collection
          isLargeDataset ? (progress) => {
            // Handle progress updates for large datasets
            if (progress.completed) {
              console.log('Large dataset processing completed:', progress.finalSummary);
            } else if (progress.error) {
              console.warn(`Batch processing error: ${progress.error}`);
            } else {
              console.log(`Processing progress: ${progress.progressPercent}% (${progress.currentIds} IDs collected)`);
            }
          } : null
        );
        
        setGlobalSearchResult(searchResultsId);
        console.log(searchResultsId, "IDs for collection:", collection);

        const matchedLink = columnsLinks.find(link => link.accessor === collection);

        if (matchedLink) {
          // setDealsView(matchedLink?.dealsView);
          // Pass the specific collection information in the navigation state
          const enhancedLabelState = {
            ...labelState,
            sourceCollection: collection, // Add the source collection to identify which collection's data to use
            globalSearchCollection: collection, // Alternative property name for clarity
            globalSearchQuery: searchInput, // Pass the search query
            globalSearchType: searchType, // Pass the search type (0 or 1)
            globalSearchResultCount: recordCount, // Pass the result count
            isFromGlobalSearch: true, // Flag to indicate this is from global search
            isLargeDataset, // Flag to indicate if this was a large dataset
          };
          sessionStorage.setItem('SearchParams', JSON.stringify({
            "input": searchInput,
            "found": foundMap,
            "type": searchType,
          }));
          navigate(matchedLink.link, { state: enhancedLabelState });
          setSearchText("");
          setMonthPickerValue(labelState.globalMonthRange)
        } else {
          console.warn('No matching link found for the provided collection:', collection);
        }
      } catch (error) {
        console.error(`Error processing view all for collection ${collection}:`, error);
        // You might want to show a user-friendly error message here
      } finally {
        // Clear loading state for this collection
        setLoadingCollections(prev => ({ ...prev, [collection]: false }));
      }
    };

    const addCommasToNumber = (number) => {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const getOrderedResults = (results, menu, selectedStaticHeaders) => {
      // Define the desired order of collection_name (ids) for each menu
      const orderedIds = {
        re: [
          're_investment',
          're_exit',
          're_ipo',
          're_investor',
          're_advisor',
          're_fund',
          're_merger_acquisition',
        ],
        ma: [
          'merger_acquisition',
          'pe_acquirer',
          'pe_advisor',
        ],
        cfs: ['cfs_company'],
        pe_vc: [
          'pe_investment',
          'pe_exit',
          'pe_ipo',
          'angel',
          'incubation',
          'pe_investor',
          'angel_investor',
          'incubator',
          'pe_fund',
          'limited_partner',
          'pe_advisor',
        ],
        pe: [
          'pe_investment',
          'pe_exit',
          'pe_ipo',
          'angel',
          'incubation',
          'pe_investor',
          'angel_investor',
          'incubator',
          'pe_fund',
          'limited_partner',
          'pe_advisor',
        ],
        vc: [
          'pe_investment',
          'pe_exit',
          'pe_ipo',
          'angel',
          'incubation',
          'pe_investor',
          'angel_investor',
          'incubator',
          'pe_fund',
          'limited_partner',
          'pe_advisor',
        ],
      };

      // Define ids to exclude for 'More Results From Other Databases'
      const excludedIds = {
        re: [
          'top_results',
          're_investment',
          're_exit',
          're_ipo',
          're_investor',
          're_advisor',
          're_fund',
          're_merger_acquisition',
        ],
        ma: [
          'merger_acquisition',
          'pe_acquirer',
          'pe_advisor',
        ],
        cfs: ['cfs_company'],
        pe_vc: [
          'top_results',
          'pe_investment',
          'pe_exit',
          'pe_ipo',
          'angel',
          'incubation',
          'pe_investor',
          'angel_investor',
          'incubator',
          'pe_fund',
          'limited_partner',
          'pe_advisor',
        ],
        pe: [
          'top_results',
          'pe_investment',
          'pe_exit',
          'pe_ipo',
          'angel',
          'incubation',
          'pe_investor',
          'angel_investor',
          'incubator',
          'pe_fund',
          'limited_partner',
          'pe_advisor',
        ],
        vc: [
          'top_results',
          'pe_investment',
          'pe_exit',
          'pe_ipo',
          'angel',
          'incubation',
          'pe_investor',
          'angel_investor',
          'incubator',
          'pe_fund',
          'limited_partner',
          'pe_advisor',
        ],
      };

      const filterResults = (idsToExclude) =>
        results.filter((result) => !idsToExclude.includes(result?.request_params?.collection_name));

      const getResultsByOrder = (ids) =>
        ids
          .map((id) => results.find((result) => result?.request_params?.collection_name === id))
          .filter(Boolean);

      switch (menu) {
        case "re":
          if (!isReFundsSearch) {
            return selectedStaticHeaders !== "More Results From Other Databases"
              ? getResultsByOrder(orderedIds.re)
              : filterResults(excludedIds.re);
          }
          return getResultsByOrder(['re_fund']);
        case "ma":
          return selectedStaticHeaders !== "More Results From Other Databases"
            ? getResultsByOrder(orderedIds.ma)
            : filterResults(excludedIds.ma);
        case "cfs":
          return selectedStaticHeaders !== "More Results From Other Databases"
            ? getResultsByOrder(orderedIds.cfs)
            : filterResults(excludedIds.cfs);
        case "pe":
          if (!isPeFundsSearch) {
            return selectedStaticHeaders !== "More Results From Other Databases"
              ? getResultsByOrder(orderedIds.pe)
              : filterResults(excludedIds.pe);
          }
          return getResultsByOrder(['pe_fund']);
        case "vc":
          if (!isVcFundsSearch) {
            return selectedStaticHeaders !== "More Results From Other Databases"
              ? getResultsByOrder(orderedIds.vc)
              : filterResults(excludedIds.vc);
          }
          return getResultsByOrder(['pe_fund']);
        default:
          return filterResults(["top_results"]);
      }
    };

    // Render conditional content based on loading state and results
    const renderSearchResults = () => {
      if (isloading) {
        return <h1 className="mx-auto font-semibold text-center">Loading...</h1>;
      }

      if (!isloading && searchResult.length === 0) {
        return (
          <div className="h-40 flex flex-col justify-center items-center">
            <h1 className="mx-auto font-semibold text-center">No Results Found</h1>
            {searchType !== 0 && (
              <h2 className="mx-auto font-semibold text-center">
                You may change the search to <span className="font-semibold">broad match </span> and check again.
              </h2>
            )}
          </div>
        );
      }

      if (selectedStaticHeaders === "Top Results") {
        return (
          <div className="mx-auto w-full gap-y-6 sm:gap-6 md:pb-2 max-h-full">
            <TopResultColumn result={searchResult[0]} searchResult={searchResult} />
            {searchResult[0]?.found > (searchResult[0].page*5) && (
              <div className="flex gap-2 justify-center items-center">
                <h3
                  className={`ml-8 mt-2 text-right cursor-pointer rounded px-4 py-1 flex items-center gap-2 ${
                    loadingViewMore[searchResult[0]?.request_params?.collection_name]
                      ? 'bg-[#BC8B20] opacity-60 cursor-not-allowed'
                      : 'bg-[#BC8B20] hover:bg-[#A67A1B]'
                  } text-white`}
                  onClick={() => {
                    if (!loadingViewMore[searchResult[0]?.request_params?.collection_name]) {
                      viewMoreHandler(searchResult[0]?.request_params?.collection_name);
                    }
                  }}
                >
                  {loadingViewMore[searchResult[0]?.request_params?.collection_name] ? (
                    <>
                      <LoadingSpinner />
                      Loading...
                    </>
                  ) : (
                    'View more'
                  )}
                </h3>
              </div>
            )}
          </div>
        );
      }

      // Get ordered results based on the current menu and static header
      const orderedResults = getOrderedResults(searchResult, menu, selectedStaticHeaders);
      // console.log(orderedResults, "orderedResults", selectedStaticHeaders);

      return (
        <div className="mx-auto w-full gap-y-6 sm:gap-6 md:pb-2 max-h-full">
          {orderedResults?.map((result, index) => {
            if (result?.found === 0) return null;

            return (
              <div
                key={index}
                className={`border-t rounded ${result?.found >= 5 && result?.found !== result?.hits?.length && result?.hits?.length !== 0 || !result?.hits?.some((hit) => hit.document?.advisor_type) ? 'py-2' : 'pt-2'} bg-white ${gsExpand ? 'mx-6 mb-6' : 'm-6 md:mt-2 '}`}
                id={result?.request_params?.collection_name}
              >
                <h1 className="md:text-base font-semibold md:pl-4 mb-2">
                  {typeof collectionNameMapHuman[result?.request_params?.collection_name] === 'function'
                    ? collectionNameMapHuman[result?.request_params?.collection_name](result)
                    : collectionNameMapHuman[result?.request_params?.collection_name]}
                </h1>
                <SearchResult result={result} searchResult={searchResult} check={check} />
                <div className="flex gap-2 justify-center items-center">
                  {result?.found > (result.page*5) && (
                    <h3
                      className={`ml-8 mt-2 text-right cursor-pointer rounded px-4 py-1 flex items-center gap-2 ${
                        loadingViewMore[result?.request_params?.collection_name]
                          ? 'bg-[#BC8B20] opacity-60 cursor-not-allowed'
                          : 'bg-[#BC8B20] hover:bg-[#A67A1B]'
                      } text-white`}
                      onClick={() => {
                        if (!loadingViewMore[result?.request_params?.collection_name]) {
                          viewMoreHandler(result?.request_params?.collection_name);
                        }
                      }}
                    >
                      {loadingViewMore[result?.request_params?.collection_name] ? (
                        <>
                          <LoadingSpinner />
                          Loading...
                        </>
                      ) : (
                        'View more'
                      )}
                    </h3>
                  )}
                  {!result?.hits?.some((hit) => hit.document?.advisor_type) && result?.request_params?.collection_name !== 're_advisor' && (
                    <h3
                      className={`ml-8 mt-2 text-right cursor-pointer rounded px-4 py-1 flex items-center gap-2 ${
                        loadingCollections[result?.request_params?.collection_name] 
                          ? 'bg-[#BC8B20] opacity-60 cursor-not-allowed' 
                          : 'bg-[#BC8B20] hover:bg-[#A67A1B]'
                      } text-white`}
                      onClick={() => {
                        if (!loadingCollections[result?.request_params?.collection_name]) {
                          viewAllHandler(result?.request_params?.collection_name, {
                            globalSearch: [{ id: 0, name: `searched for ${searchInput}`, searchTerm: searchInput, searchType }],
                            globalMonthRange: ["1998-01-01", moment().startOf('second').format("YYYY-MM-DD")],
                          });
                        }
                      }}
                    >
                      {loadingCollections[result?.request_params?.collection_name] ? (
                        <>
                          <LoadingSpinner />
                          Loading...
                        </>
                      ) : (
                        'View all'
                      )}
                    </h3>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      );
    };
  
    return (
      <>
        <div className="ml-[75px] fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity h-screen">
          <div className="w-full mt-[3rem] overflow-hidden">
            <div className="w-full h-full max-h-[98vh] border bg-[#ebebeb] relative flex flex-col">
              {!isloading ? (
                menu === "pe" ? 
                  <RenderHeaders headers={peStaticHeaders} />
                  : menu === "vc" ?
                  <RenderHeaders headers={vcStaticHeaders} />
                  : menu === "ma" ?
                    <RenderHeaders headers={maStaticHeaders} />
                  : menu === "re" ?
                    <RenderHeaders headers={reStaticHeaders} />
                  : menu === "cfs" ?
                    <RenderHeaders headers={cfsStaticHeaders} />
                  :
                  <RenderHeaders headers={staticHeaders} />
              ) : null}
              <div ref={resultsContainerRef} className={`flex-1 overflow-y-auto overflow-x-auto px-2 scrollbar-remove no-scrollbar w-full mx-auto ${selectedStaticHeaders === "Company Financials" ? "" : "pb-5"}`}>
                {renderSearchResults()}
              </div>
            </div>
          </div>
        </div>
    </>
    
    )
}

export default NewSearchResult;